{
  "dataTable": {
    "view": "Megtekintés",
    "columns": "Oszlopok",
    "rowsSelected_one": "{{count}}/{{total}} sor kiválasztva",
    "rowsSelected_other": "{{count}}/{{total}} sor kiválasztva",
    "totalResults_one": "{{count}} eredmény",
    "totalResults_other": "{{count}} eredmény",
    "filteredResults_one": "{{filtered}}/{{total}} eredmény",
    "filteredResults_other": "{{filtered}}/{{total}} eredmény",
    "rowsPerPage": "Sorok oldalanként",
    "page": "{{current}}/{{total}} oldal",
    "noResults": "Nincs találat.",
    "noResultsFound": "Nincs találat.",
    "pagination": {
      "goToFirstPage": "Ugrás az első oldalra",
      "goToPreviousPage": "Ugrás az előző oldalra",
      "goToNextPage": "Ugrás a következő oldalra",
      "goToLastPage": "Ugrás az utolsó oldalra"
    },
    "search": "Keresés...",
    "filterValuePlaceholder": "{{label}} megadása...",
    "selectPlaceholder": "Kiválasztás...",
    "sortAscending": "Növekvő rendezés",
    "sortDescending": "Csökkenő rendezés",
    "sortThenAscending": "Ezután növekvő",
    "sortThenDescending": "Ezután csökkenő",
    "sortRank": "Rendezési sorrend {{rank}}",
    "clearSort": "Rendezés törlése",
    "addFilter": "Szűrő hozzáadása",
    "clearFilter": "Szűrő törlése",
    "hideColumn": "Oszlop elrejtése",
    "filtered": "Szűrt",
    "groupBy": "Csoportosítás: {{label}}",
    "filters": {
      "searchPlaceholder": "Keresés...",
      "selectPlaceholder": "Kiválasztás...",
      "all": "Összes",
      "from": "Ettől",
      "to": "Eddig",
      "min": "Min",
      "max": "Max",
      "activeFilters": "Aktív szűrők",
      "clearAll": "Összes törlése",
      "removeFilter": "Szűrő eltávolítása"
    },
    "resetColumns": "Alapértelmezés visszaállítása"
  }
}
